import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from '@sm/components/App';
import store from'@sm/reducers/index';

import 'material-symbols/outlined.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={ store }>
    <App />
  </Provider>
);